'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);


var _components = require('../../../components');


var _MapboxService = require('../../../services/MapboxService/MapboxService');


var _PropertyMap = require('./PropertyMap.scss');var _PropertyMap2 = _interopRequireDefault(_PropertyMap);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// styles
var StaticPropertyMap = function (_Component) {_inherits(StaticPropertyMap, _Component);function StaticPropertyMap() {var _temp, _this, _ret;_classCallCheck(this, StaticPropertyMap);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      staticMapLink: '' }, _this.















    calcMapMetrics = function (isMobile) {
      var metrics = { width: 1280, height: 500 };

      if (isMobile) {
        metrics.width = global && global.document && global.document.body.clientWidth || 375;
        metrics.height = 184;
      }

      return metrics;
    }, _this.

    initialiseStaticMap = function () {var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.locale;var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.isMobile;var _this$props$location =
      _this.props.location,lat = _this$props$location.lat,lon = _this$props$location.lon;
      var pins = [lon + ',' + lat];
      var staticMapboxImage = (0, _get2.default)(_this.props, 'staticMapboxImage.' + locale);

      if (!!staticMapboxImage) {
        _this.setState({ staticMapLink: staticMapboxImage });
      } else {var _this$calcMapMetrics =
        _this.calcMapMetrics(isMobile),width = _this$calcMapMetrics.width,height = _this$calcMapMetrics.height;
        var staticMapLink = (0, _MapboxService.constructStaticMapLink)(
        pins,
        { width: width, height: height },
        undefined,
        locale);

        _this.setState({ staticMapLink: staticMapLink });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}StaticPropertyMap.prototype.componentDidMount = function componentDidMount() {this.initialiseStaticMap();};StaticPropertyMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var localeIsChanged = newProps.locale && newProps.locale !== this.props.locale;var isMobileIsChanged = newProps.isMobile !== this.props.isMobile;if (localeIsChanged || isMobileIsChanged) {this.initialiseStaticMap(newProps.locale, newProps.isMobile);}};StaticPropertyMap.prototype.

  render = function render() {var _cx;var _props =
    this.props,switchToDynamicMap = _props.switchToDynamicMap,locale = _props.locale;var
    staticMapLink = this.state.staticMapLink;
    var staticMapboxImage = (0, _get2.default)(this.props, 'staticMapboxImage.' + locale);

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(_PropertyMap2.default.staticMap, (_cx = {}, _cx[_PropertyMap2.default.staticMapboxImage] = !!staticMapboxImage, _cx)),
          onClick: switchToDynamicMap,
          onMouseDown: switchToDynamicMap },

        _react2.default.createElement('img', { src: staticMapLink, alt: '' }),
        _react2.default.createElement(_components.MapControlButtons, null)));


  };return StaticPropertyMap;}(_react.Component);


StaticPropertyMap.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  staticMapboxImage: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  location: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  isModal: _propTypes2.default.bool,
  switchToDynamicMap: _propTypes2.default.func };exports.default =


StaticPropertyMap;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyMap/StaticPropertyMap.js
// module id = 2830
// module chunks = 0